import React, { useRef, useState } from 'react'
import {
  Button,
  Table,
  Card,
  Divider,
  Popconfirm,
  Input,
  Icon,
  Form,
  Avatar
} from 'antd'
import AddBarcodeProduct from './components/AddBarcodeProduct'
import EditBarcodeProduct from './components/EditBarcodeProduct'
import Highlighter from 'react-highlight-words'
import { useDispatch, useSelector } from 'react-redux'
import {
  deleteBarcodeById,
  getBarcodeProduct,
  getBarcodeProductCategory,
} from '../../modules/barcodeProduct'
import { compose, withApollo, graphql } from 'react-apollo'
import { useDeepEffect } from '../../utils/hooks'
import Lightbox from "react-image-lightbox";
import "../../../node_modules/react-image-lightbox/style.css";

const initialOptions = {
  size: 20,
  page: 0,
  desc: true
}

const BarcodeProduct = ({ data, form }) => {
  const dispatch = useDispatch()
  let searchInput = useRef(null)
  const [options, setOptions] = useState(initialOptions)
  const [openAddModal, setOpenAddModal] = useState(false)
  const [openEditModal, setOpenEditModal] = useState(false)
  const [formData, setFormData] = useState({})
  const [searchText, setSearchText] = useState('')
  const [current , setCurrent] = useState('')

  const { barcodeProductObj } = useSelector(
    (state) => ({
      barcodeProductObj: state.barcodeProduct.barcodeProductObj
    }),
    []
  )

  const { barcodeCategory  } = useSelector(
    (state) => ({
      barcodeCategory: state.barcodeProduct.barcodeCategory.data
    }),
    []
  )

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(getBarcodeProduct(options))
      await dispatch(getBarcodeProductCategory())
    }

    fetch()
  }, [])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleClickImage = (e, image) => {
    e && e.preventDefault();
    setCurrent(image)
  };

  const handleCloseModal = e => {
    e && e.preventDefault();
    setCurrent('')
  };

  const columns = [
    {
      title: 'รูปภาพ',
      dataIndex: 'images',
      key: 'images',
      render: (name, row) => (
        <div>
          <Avatar src={row.images} alt="" size={64} onClick={e => handleClickImage(e, row.images)}/>        
          {current && (
          <Lightbox mainSrc={current} onCloseRequest={handleCloseModal} />
        )}
        </div>
      )
    },
    {
      title: 'ชื่อ BarcodeProduct',
      dataIndex: 'name',
      key: 'name',
      ...getColumnSearchProps('name'),
      render: (name, row) => <div>{`${row.name} ${row.brand}`}</div>
    },
    {
      title: 'ประเภทสินค้า',
      key: 'categoryName',
      dataIndex: 'categoryName'
    },
    {
      title: 'ผู้ค้นพบ',
      key: 'createdBy',
      dataIndex: 'createdBy'
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={() => {
              openDialog(record.id)
            }}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const onClick = (e) => {
    e.preventDefault()
    setOpenAddModal(true)
  }

  const onCloseModal = (key) => {
    setFormData({})
    switch (key) {
      case 'openAddModal':
        setOpenAddModal(false)
        break
      case 'openEditModal':
        setOpenEditModal(false)
        break
      default:
        return null
    }
  }

  const onDelete = async (id) => {
    await dispatch(deleteBarcodeById(id))
    await dispatch(getBarcodeProduct(options))
  }

  const openDialog = async (id) => {
    // Set data id
    await setOpenEditModal(true)
    await setFormData({
      id
    })
  }

  const refetchData = async () => {
    await dispatch(getBarcodeProduct(options))
  }

  async function onShowSizeChange(current, pageSize) {
    options.size = pageSize
    setOptions(options)
    await dispatch(getBarcodeProduct(options))
  }

  async function onChange(page) {
    options.page = page - 1
    setOptions(options)
    await dispatch(getBarcodeProduct(options))
  }

  const reset = async (e) => {
    e.preventDefault()
    options.keyword = ''
    await dispatch(getBarcodeProduct(options))
    await form.resetFields()
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    form.validateFields(async (err, values) => {
      if (!err) {
        if (values.keyword) {
          options.keyword = values.keyword
          options.page = 0
          setOptions(options)
          await dispatch(getBarcodeProduct(options))
        } else {
          options.keyword = ''
          options.page = 0
          await dispatch(getBarcodeProduct(options))
        }
      }
    })
  }

  return (
    <Card
      title="BarcodeProduct"
      extra={
        <div>
          <Button size="small" icon="plus" onClick={(e) => onClick(e)}>
            New BarcodeProduct
          </Button>
          <Button size="small" icon="reload" onClick={() => refetchData()}>
            Reload
          </Button>
        </div>
      }>
      <Form layout="inline" onSubmit={handleSubmit}>
        <Form.Item label="keyword">
          {form.getFieldDecorator('keyword')(
            <Input placeholder="บาร์โค้ด,ชื่อสินค้า,ยี่ห้อสินค้า" />
          )}
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            ค้นหา
          </Button>
        </Form.Item>
        <Form.Item>
          <Button onClick={(e) => reset(e)}>รีเซ็ต</Button>
        </Form.Item>
      </Form>
      <br />
      <Table
        bordered
        rowKey={(record) => record.id}
        dataSource={barcodeProductObj.content}
        columns={columns}
        pagination={{
          current: barcodeProductObj.pageable.pageNumber + 1,
          pageSize: barcodeProductObj.size,
          pageSizeOptions: ['10', '20', '50', '100'],
          showSizeChanger: true,
          onShowSizeChange: onShowSizeChange,
          onChange: onChange,
          total: barcodeProductObj.totalElements
        }}
      />
      <AddBarcodeProduct
        values={barcodeCategory}
        onClose={() => onCloseModal('openAddModal')}
        visible={openAddModal}
        refetchData={refetchData}
      />
      {openEditModal && (
        <EditBarcodeProduct
          barcodeId={formData.id}
          values={barcodeCategory}
          onClose={() => onCloseModal('openEditModal')}
          visible={openEditModal}
          refetchData={refetchData}
        />
      )}
    </Card>
  )
}
const WrappedBarcodeProduct = Form.create({ name: 'customized_form_controls' })(
  BarcodeProduct
)
export default compose(
  withApollo
)(WrappedBarcodeProduct)



// WEBPACK FOOTER //
// ./src/pages/BarcodeProduct/index.js